import { useNavigate, useParams } from 'react-router-dom';
import PageHeader from 'src/components/page-header/page-header';
import { KBModule } from 'src/types';
import { skeletons } from '../knowledge-base';
import css from '../knowledge-base.module.scss';
import CarouselCard from 'src/components/carousel/carousel-card';
import { KNOWLEDGE_BASE } from 'src/constants/routes';
import { useGetSection } from '../data/queries';
import { useMetaContext } from 'src/hooks/meta-context';
import generalBannerSoldier from 'src/assets/general/general-banner-soldier.webp';

function Section() {
  const { slug } = useParams();
  const { updateMetaInfo } = useMetaContext();
  const navigate = useNavigate();
  const page = [
    {
      path: KNOWLEDGE_BASE.path,
      title: KNOWLEDGE_BASE.title
    }
  ];

  const { data: section, isPending } = useGetSection(`${slug}`);

  const goToMaterial = (module: string) => navigate(module);

  section &&
    updateMetaInfo({
      title: KNOWLEDGE_BASE.meta.title,
      description: KNOWLEDGE_BASE.meta.description,
      openGraph: {
        title: section.title,
        description: section.description.replace(/<\/?[^>]+(>|$)/g, ''),
        img: section.imgUrl ?? generalBannerSoldier,
        type: 'website'
      }
    });

  return (
    <main className={css.knowledge}>
      <PageHeader title={section?.title ?? ''} description={section?.description ?? ''} pages={page} />
      <div className={css.body}>
        <div className={css.container}>
          <div className={css.cards}>
            {isPending && skeletons}
            {section &&
              section?.modules?.length > 0 &&
              section.modules.map((m: KBModule) => (
                <CarouselCard key={m.id} item={m} hide={false} onClick={() => goToMaterial(m.slug)} />
              ))}
          </div>
        </div>
      </div>
    </main>
  );
}

export default Section;
